/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Tooltip, TextField, Typography, InputAdornment } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import toJs from "../../../hoc/toJS";
import select from "../../../utils/select";

import KPTable from "../../../components/KPTable";
import SolutionUpdateModal from "../SolutionUpdateModal";
import SolutionDeleteModal from "../SolutionDeleteModal";
import {
  WorkflowStatusChip,
  RevisionRequestLink,
  RevisionRequestDialog,
  STATUS_META,
  workflowMetaColumns,
  WorkflowFilterBar,
  ExportExcelButton,
  applyConditions,
} from "../../../components/WorkflowStatus";

import { statisticUnaccepted } from "../../../reducer/profile/action";
import { acceptSolution, updateSolution, requestRevisionSolution } from "../../../reducer/solution/action";
import { changePages } from "../../../reducer/home/action";
import HistoryModal from "../../../components/common/HistoryModal";

const deriveStatus = (row) => {
  if (row?.revisionStatus === "requested") return "revisionRequested";
  if (row?.revisionStatus === "resubmitted") return "resubmitted";
  if (row?.accepted) return "approved";
  return "pending";
};

function SolutionTable(props) {
  const [editting, setEditting] = useState(null);
  const [updating, setUpdating] = useState(null);
  const [deleting, setDeleting] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [historyRow, setHistoryRow] = useState(null);
  const [revisionRow, setRevisionRow] = useState(null);
  const [revisionSubmitting, setRevisionSubmitting] = useState(false);
  const [advancedConditions, setAdvancedConditions] = useState([]);
  useEffect(() => {
    setAdvancedConditions([]);
  }, [props.type]);

  const handleUpdate = (e) => setUpdating(e);
  const handleEditYear = (e) => setEditting(e);

  const handleDelete = (event, e) => {
    setDeleting(e.id);
    setAnchorEl(event.currentTarget);
  };

  const handleChange = (value) => setEditting({ ...editting, dashboardYear: value });

  const handleAccept = (e) => {
    props.acceptSolution(e.id, !e.accepted).then((success) => {
      if (success) {
        props.statisticUnaccepted({ departmentId: 0, profileId: props.profile?.id });
        if (props.role === "sudo-admin") props.statisticUnaccepted({ departmentId: 0, profileId: 0 });
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    props.updateSolution(editting.id, editting);
    setEditting(null);
  };

  const handleClear = () => {
    props.updateSolution(editting.id, { ...editting, dashboardYear: null });
    setEditting(null);
  };

  const list = [];
  if (props.type === "all") props.listSolution.forEach((e) => list.push(e.solution));
  else props.listSolutionById.forEach((e) => list.push(e.solution));

  const enrichedRows = list.map((item) => ({ ...item, _status: deriveStatus(item) }));
  const filteredRows = applyConditions(enrichedRows, advancedConditions);
  const departmentName = (props.departments || []).find((d) => d.id === props.department)?.name;

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", gap: 8, marginBottom: 4 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <WorkflowFilterBar
            conditions={advancedConditions}
            onChange={setAdvancedConditions}
            rows={enrichedRows}
          />
        </div>
        <ExportExcelButton rows={filteredRows} workType="solution" />
      </div>
      <KPTable
        shadow="none"
        rowsPerPage={10}
        maxHeight="calc(100vh - 320px)"
        columns={[
          {
            title: <b>Tác vụ</b>,
            key: "action",
            width: "20%",
            render: (value, row) =>
              row?.id !== editting?.id ? (
                <>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="primary"
                    onClick={() => handleUpdate(row)}
                  >
                    Chi tiết
                  </Typography>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="primary"
                    onClick={() => setHistoryRow(row)}
                  >
                    Lịch sử
                  </Typography>
                  {row.locked ? (
                    <Typography className="table-action-buton" variant="caption" color="textPrimary">
                      {`Đã khóa ${
                        (row.locked === "kpi" && "KPI") ||
                        (row.locked === "reward" && "thưởng") ||
                        (row.locked === "timeResearch" && "giờ nghiên cứu")
                      }`}
                    </Typography>
                  ) : (
                    <>
                      {(props.type !== "all" || props.role === "sudo-admin") && !row.accepted && (
                        <Typography
                          className="table-action-buton"
                          variant="caption"
                          color="secondary"
                          onClick={(event) => handleDelete(event, row)}
                        >
                          Xoá
                        </Typography>
                      )}
                      {props.role === "sudo-admin" && props.filter !== "workingPaper" && row.purposeId !== 4 && (
                        <>
                          <Typography
                            className="table-action-buton"
                            variant="caption"
                            color="primary"
                            onClick={(event) => handleAccept(row)}
                          >
                            {row.accepted ? "Hủy duyệt" : "Duyệt"}
                          </Typography>
                          <RevisionRequestLink row={row} onClick={setRevisionRow} />
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <>
                  <Typography className="table-action-buton" variant="caption" color="primary" onClick={handleSubmit}>
                    Lưu
                  </Typography>
                  <Typography
                    className="table-action-buton"
                    variant="caption"
                    color="secondary"
                    onClick={() => setEditting(null)}
                  >
                    Huỷ
                  </Typography>
                </>
              ),
          },
          {
            title: <b>Tên giải pháp</b>,
            key: "title",
            width: props.role === "sudo-admin" ? "20%" : "30%",
            searchable: true,
            sorter: (a, b) => a.title.toUpperCase().localeCompare(b.title.toUpperCase()),
          },
          {
            title: <b>Nhóm tác giả</b>,
            key: "authorTeam",
            width: "20%",
          },
          {
            title: <b>Mục đích</b>,
            key: "purposeId",
            width: "15%",
            type: "include",
            filters: props.purposes.map((e) => ({ value: e.id, text: e.description })),
            onFilter: (value, row) => row.filter((e) => value.includes(e.purposeId)),
            render: (value) => props.purposes.find((e) => e.id === value)?.description,
          },
          props.role === "sudo-admin" && props.type === "all"
            ? {
                title: <b>Năm hiển thị</b>,
                key: "dashboardYear",
                width: "12%",
                searchable: true,
                render: (value, row) =>
                  row?.id !== editting?.id ? (
                    <Tooltip title="Click để chỉnh sửa năm">
                      <div style={{ cursor: "pointer" }} onClick={() => handleEditYear(row)}>
                        {value > 0 ? value : "Chưa có năm hiển thị"}
                      </div>
                    </Tooltip>
                  ) : (
                    <form onSubmit={handleSubmit}>
                      <TextField
                        fullWidth
                        size="small"
                        type="tel"
                        variant="outlined"
                        value={editting?.dashboardYear || ""}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end" style={{ cursor: "pointer" }} onClick={handleClear}>
                              <Clear style={{ fontSize: 18 }} />
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => handleChange(parseInt(e.target.value))}
                      />
                    </form>
                  ),
              }
            : {
                key: "dashboardYear",
                width: "0%",
                render: () => null,
              },
          {
            title: <b>Trạng thái</b>,
            key: "_status",
            width: "12%",
            render: (_, row) => <WorkflowStatusChip row={row} />,
            type: "include",
            filters: Object.entries(STATUS_META).map(([value, meta]) => ({ value, text: meta.label })),
            onFilter: (value, rows) => rows.filter((e) => value.includes(e._status)),
          },
          ...workflowMetaColumns({ width: "10%" }),
        ]}
        rows={filteredRows.slice(10 * props.workPages[1], 10 * (props.workPages[1] + 1))}
        totalData={list?.length}
        loading={props.isFetching}
        page={props.workPages[1]}
        onPageChange={(newPage) => props.changePages(1, newPage - 1)}
      />
      <SolutionUpdateModal adminTab={props.adminTab} updating={updating} setUpdating={setUpdating} />
      <SolutionDeleteModal deleting={deleting} anchorEl={anchorEl} setAnchorEl={setAnchorEl} />
      <HistoryModal
        open={!!historyRow}
        row={historyRow}
        onClose={() => setHistoryRow(null)}
        modelType="solution"
        title="Lịch sử chỉnh sửa giải pháp hữu ích"
      />
      <RevisionRequestDialog
        row={revisionRow}
        submitting={revisionSubmitting}
        onClose={() => setRevisionRow(null)}
        onSubmit={async (reason) => {
          setRevisionSubmitting(true);
          const ok = await props.requestRevisionSolution(revisionRow.id, reason);
          setRevisionSubmitting(false);
          if (ok) setRevisionRow(null);
        }}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  role: select(state, "userReducer", "role"),
  profile: select(state, "profileReducer", "detail"),
  workPages: select(state, "homeReducer", "workPages"),
  isFetching: select(state, "solutionReducer", "isFetching"),
  listSolution: select(state, "solutionReducer", "listFiltered"),
  listSolutionById: select(state, "solutionReducer", "listById"),
  purposes: select(state, "scientificResearchReducer", "purposes"),
  departments: select(state, "departmentReducer", "departments"),
});

const mapDispatchToProps = (dispatch) => ({
  acceptSolution: (id, accept) => dispatch(acceptSolution(id, accept)),
  updateSolution: (id, payload) => dispatch(updateSolution(id, payload)),
  requestRevisionSolution: (id, reason) => dispatch(requestRevisionSolution(id, reason)),
  statisticUnaccepted: (payload) => dispatch(statisticUnaccepted(payload)),
  changePages: (id, newPage) => dispatch(changePages(id, newPage)),
});

export default connect(mapStateToProps, mapDispatchToProps)(toJs(SolutionTable));

